<template>
  <div class="row">
    <div
      class="col-xl-4"
      v-for="(data, i) in infoData"
      :key="i"
    >
      <div class="card card-animate" :class="loading ? 'placeholder-glow' : ''" >
        <div class="card-body" style="text-align: left">
          <div class="d-flex align-items-center justify-content-between">
            <div class="avatar-sm flex-shrink-0">
              <span
                class="avatar-title bg-soft-primary text-primary rounded-2 fs-2"
                :class="{
                  placeholder: loading,
                  'bg-soft-warning': i % 2 !== 0,
                }"
                style="width: 50px; height: 50px"
              >
                <i v-if="!loading" :class="data.icon"></i>
              </span>
            </div>
            <div class="flex-grow-1 overflow-hidden ms-3">
              <p
                class="text-uppercase fw-semibold text-muted text-truncate mb-3 rounded-2"
                :class="loading ? 'placeholder' : ''"
                style="height: 16px; width: 60%"
              >
                {{ loading ? "" : data.title }}
              </p>
              <div class="d-flex align-items-center mb-3">
                <h4 class="fs-4 flex-grow-1 mb-0">
                  <span
                    style="height: 10px; width: 50%"
                    class="counter-value rounded-2"
                    :class="loading ? 'placeholder' : ''"
                    data-target="825"
                  >
                    {{ loading ? "" : data.count }}
                  </span>
                </h4>
           
              </div>
              <p
                class="text-muted text-truncate mb-0 rounded-2"
                :class="{ placeholder: loading }"
                style="height: 16px; width: 80%"
              >
                {{ loading ? "" : data.percentage }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "infoCard",
  props: {
    infoData: Array,
    loading: Boolean,
  },
};
</script>
